import { VenueSpace } from "@prisma/client";
import axios from "axios";

export async function createVenueSpace(data: Omit<VenueSpace, "id">) {
  const response = await axios.post("/api/venue-space", data);
  return response.data;
}

export async function updateVenueSpace(id: string, data: Partial<VenueSpace>) {
  const response = await axios.patch(`/api/venue-space/${id}`, data);
  return response.data;
}

export async function deleteVenueSpace(id: string) {
  const response = await axios.delete(`/api/venue-space/${id}`);
  return response.data;
}
